module.exports = __webpack_public_path__ + "img/biology.2cb76eab.svg";